var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('FormItem', {
    key: _vm.showPrepend,
    staticClass: "area-phone-input",
    attrs: {
      "label": _vm.showPrepend ? $t("ewbd43", "手机号") : $t("padf2", "邮箱"),
      "prop": "account",
      "position": "top"
    }
  }, [_vm.showPrepend ? _c('Input', {
    staticClass: "area-code-input max-w-[82px]",
    attrs: {
      "value": _vm.inviteInfo.mobileAreaCode,
      "readonly": ""
    }
  }, [_c('template', {
    slot: "suffix"
  }, [_c('Icon', {
    attrs: {
      "id": "area-code-input",
      "type": _vm.isFocused ? 'md-arrow-dropup' : 'md-arrow-dropdown'
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleClick.apply(null, arguments);
      }
    }
  })], 1)], 2) : _vm._e(), _c('Input', {
    staticClass: "w-full min-w-[250px]",
    class: {
      'phone-input': _vm.showPrepend
    },
    attrs: {
      "type": "phone",
      "value": _vm.inviteInfo.account,
      "placeholder": _vm.showPrepend ? $t("7ji3y96", "请输入手机号") : $t("2j0utw5", "请输入邮箱")
    },
    on: {
      "on-change": _vm.changeAccount
    }
  }), _vm.isFocused && _vm.showPrepend ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.onClickOutside,
      expression: "onClickOutside"
    }],
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "index-list"
  }, [_c('ul', {
    ref: "indexWrap",
    staticClass: "index-list-wrap",
    on: {
      "scroll": _vm.onListWrapScroll
    }
  }, _vm._l(_vm.data, function (group, index) {
    return _c('li', {
      key: index,
      ref: String(group.title || '').substring(0, 1) || '·',
      refInFor: true,
      staticClass: "index-group",
      attrs: {
        "id": String(group.title || '').substring(0, 1) || '·'
      }
    }, [_c('OverflowTooltipText', {
      attrs: {
        "text": group.title,
        "max-width": 300,
        "text-class": "index-group-title",
        "tooltip-class": "country-code-title-tooltip",
        "tooltip-style": {
          display: 'block',
          width: '100%',
          minWidth: 0
        }
      }
    }), _c('ul', _vm._l(group.items, function (item, index) {
      return _c('li', {
        key: index,
        staticClass: "index-group-item",
        class: {
          active: item.id === _vm.inviteInfo.mobileAreaCode
        },
        on: {
          "click": function ($event) {
            return _vm.clickItem(item);
          }
        }
      }, [_c('span', {
        staticClass: "code"
      }, [_vm._v(_vm._s(item.id))]), _c('OverflowTooltipText', {
        attrs: {
          "text": item.name,
          "max-width": 300,
          "text-class": "country-code-name",
          "tooltip-class": "country-code-name-tooltip",
          "tooltip-style": {
            display: 'block',
            flex: '1 1 auto',
            minWidth: 0,
            overflow: 'hidden'
          }
        }
      })], 1);
    }), 0)], 1);
  }), 0), _c('div', {
    staticClass: "index-nav"
  }, [_c('ul', _vm._l(_vm.indexList, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "nav-item",
      class: {
        active: _vm.currentIndex === item
      },
      attrs: {
        "data-index": index
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.scrollTo(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 0)])])]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };